<div class="pt-8 px-16">
  <app-corporation-details *ngIf="selectedModalStep === 1"></app-corporation-details>
  <app-corporation-primary-contact *ngIf="selectedModalStep === 2"></app-corporation-primary-contact>
</div>